export default "__VITE_ASSET__BJ5rWAyd__"